import script from "./reusableViewSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./reusableViewSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./reusableViewSwitcher.vue?vue&type=style&index=0&id=63a0ceea&lang=css"

const __exports__ = script;

export default __exports__